export const getLinkMeta = async link => {
  const response = await fetch(
    `/forms/links/metadata?link=${encodeURIComponent(link)}`,
    {
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    }
  )
  return response.json()
}
